'use client';

import { useQuery } from '@tanstack/react-query';

import {
  getVehicleMakes,
  getVehicleModels,
  getVehiclePartNames,
  getVehicleTypes,
} from '@/lib/rate-master/lookups-api';

const lookupKeys = {
  all: ['rate-master-v2', 'lookups'] as const,
  vehicleTypes: () => [...lookupKeys.all, 'vehicle-types'] as const,
  vehicleMakes: (vehicleTypeId: number | null) =>
    [...lookupKeys.all, 'vehicle-makes', vehicleTypeId] as const,
  vehicleModels: (vehicleMakeId: number | null) =>
    [...lookupKeys.all, 'vehicle-models', vehicleMakeId] as const,
  vehiclePartNames: (vehicleTypeId: number | null) =>
    [...lookupKeys.all, 'vehicle-part-names', vehicleTypeId] as const,
};

const STALE_TIME = 10 * 60 * 1000;

export function useVehicleTypes() {
  return useQuery({
    queryKey: lookupKeys.vehicleTypes(),
    queryFn: getVehicleTypes,
    staleTime: STALE_TIME,
  });
}

export function useVehicleMakes(vehicleTypeId: number | null) {
  return useQuery({
    queryKey: lookupKeys.vehicleMakes(vehicleTypeId),
    queryFn: () => getVehicleMakes(vehicleTypeId),
    enabled: vehicleTypeId !== null,
    staleTime: STALE_TIME,
  });
}

export function useVehicleModels(vehicleMakeId: number | null) {
  return useQuery({
    queryKey: lookupKeys.vehicleModels(vehicleMakeId),
    queryFn: () => getVehicleModels(vehicleMakeId),
    enabled: vehicleMakeId !== null,
    staleTime: STALE_TIME,
  });
}

export function useVehiclePartNames(vehicleTypeId: number | null) {
  return useQuery({
    queryKey: lookupKeys.vehiclePartNames(vehicleTypeId),
    queryFn: () => getVehiclePartNames(vehicleTypeId),
    staleTime: STALE_TIME,
  });
}
